import React, { useEffect, useRef, useState } from "react";
import { Button, LinearProgress } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import { setAuditID, set_latitude_longitude } from "../../store/images";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { SnackbarAlert } from "../../custom-component/AlertMessage";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from "@mui/material";
import {
  setAlertMessageSnackbarMessageSeverity,
  setAlertMessageSnackbarMsg,
  setAlertMessageSnackbarOpen,
  setLoading,
} from "../../store/feedback";
import StartIcon from "@mui/icons-material/Start";
import "./startInspection.css";
import { useFullscreen } from "../../context/FullScreenContext";
// import FileContext from "../context/Context";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import InstructionSlider from "./InstructionSlider";
import Support from "../../contact-popup-module/Support";
import "../location-camera-permission/Permission.css";
import NetworkSpeed from "../internet-strength/NetworkSpeed";
import StepIndicator from "../location-camera-permission/StepIndicator";
import CloseIcon from "@mui/icons-material/Close";
import {
  
  IconButton,
 
} from "@mui/material";
import InternetSignal from "../internet-strength/InternetSignal";

const StartInspectionHybrid = () => {
  const dispatch = useDispatch();
  const { audit_id } = useParams();

  const create_gif = `${process.env.PUBLIC_URL}/inspection-images/create_audit.gif`;
  const camera_gif = `${process.env.PUBLIC_URL}/inspection-images/camera.gif`;
  const location_gif = `${process.env.PUBLIC_URL}/inspection-images/location.gif`;
  const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;


  const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const { loading } = useSelector((state) => state.feedbackStore);
  const [location, setLocation] = useState({});


  const [openPermissionDialog, setOpenPermissionDialog] = useState(false);

  const [openCamPermissionDialog, setOpenCamPermissionDialog] = useState(false);
  const [openLocPermissionDialog, setOpenLocPermissionDialog] = useState(false);
  const [cameraPerm, setCameraPerm] = useState(false);
  const [locationPerm, setLocationPerm] = useState(false);
  const [camLocPerm, setCamLocPerm] = useState(false);

  const camPermissionAnimationRef = useRef(null);

  const [loadingMargin, setLoadingMargin] = useState("0rem");
  const navigate = useNavigate();

  const [showError, setShowError] = useState(false);
  const [dialogWidth, setDialogWidth] = useState("25vw");
  const [dialogText, setDialogText] = useState("0.9rem");

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [deviceType, setDeviceType] = useState(null);

  const [locationPermission, setLocationPermission] = useState(null);
  const [cameraPermission, setCameraPermission] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true);

  const prevLocationPermission = usePrevious(locationPermission);
  const prevCameraPermission = usePrevious(cameraPermission);

  const [lastSlide,setLastSlide] =useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionType, setConnectionType] = useState(null);
  const [effectiveType, setEffectiveType] = useState(null);
  const [downlink, setDownlink] = useState(null);
  const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
  const [speed, setSpeed] = useState(null);

  useEffect(() => {
    // Function to update connection status
    const updateConnectionStatus = () => {
      setIsOnline(navigator.onLine);

      if (navigator.connection) {
        setConnectionType(navigator.connection.type);
        setEffectiveType(navigator.connection.effectiveType);
        setDownlink(navigator.connection.downlink); // Downlink speed in Mbps
      }
    };

    // Check connection on mount
    updateConnectionStatus();

    // Event listeners for online/offline
    window.addEventListener('online', updateConnectionStatus);
    window.addEventListener('offline', updateConnectionStatus);

    // If the Network Information API is available, listen for changes in connection type
    if (navigator.connection) {
      navigator.connection.addEventListener('change', updateConnectionStatus);
    }

    return () => {
      window.removeEventListener('online', updateConnectionStatus);
      window.removeEventListener('offline', updateConnectionStatus);

      if (navigator.connection) {
        navigator.connection.removeEventListener('change', updateConnectionStatus);
      }
    };
  }, []);

  const handleClickOpen = () => {
    setOpenSupport(true);
  };
  const handleDialogClose = event => {
   
    setOpenDialogLowInternet(false);
  };

  
  
  const checkPermissions = async () => {
    if (navigator.permissions) {
      const locationStatus = await navigator.permissions.query({
        name: "geolocation",
      });
      const cameraStatus = await navigator.permissions.query({
        name: "camera",
      });

      setLocationPermission(locationStatus.state);

      setCameraPermission(cameraStatus.state);
    }
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {

          setPosition({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLocationPerm(true);
          console.log("location called", "275");
        },
        (error) => {
          console.log(error);
          setLocationPerm(false);
        }
      );
    }
  };

  useEffect(() => {
    checkPermissions().then(() => setInitialLoad(false));
  }, []);
  console.log(initialLoad, prevLocationPermission, locationPermission, "97")
  useEffect(() => {
    // setLocationPermission("heuu");

    if (
      !initialLoad &&
      prevLocationPermission &&
      locationPermission !== prevLocationPermission
    ) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 1000);
      return () => clearTimeout(timer); // Cleanup the timeout if the component unmounts
    }
  }, [locationPermission, prevLocationPermission, initialLoad]);

  console.log(initialLoad, prevCameraPermission, cameraPermission, "107")
  useEffect(() => {
    if (
      !initialLoad &&
      prevCameraPermission &&
      cameraPermission !== prevCameraPermission
    ) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 1000);
      return () => clearTimeout(timer); // Cleanup the timeout if the component unmounts
    }
  }, [cameraPermission, prevCameraPermission, initialLoad]);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  }

  useEffect(() => {
    checkPermissions();
  }, []);
  useEffect(() => {
    const intervalId = setInterval(checkPermissions, 3000); // Poll every 3 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (deviceType !== "iPhone") {
      if (
        prevLocationPermission &&
        prevLocationPermission !== locationPermission
      ) {
        window.location.reload();
      }
    }
  }, [locationPermission, prevLocationPermission]);
  useEffect(() => {
    if (deviceType !== "iPhone") {
      if (prevCameraPermission && prevCameraPermission !== cameraPermission) {
        window.location.reload();
      }
    }
  }, [cameraPermission, prevCameraPermission]);

  useEffect(() => {
    const deviceType = getDeviceType();
    setDeviceType(deviceType);
  }, []);

  const getDeviceType = () => {
    const os = window.platform.os;

    if (os.family === "iOS") {
      return "iPhone";
    } else if (os.family === "Android") {
      return "Android";
    } else {
      const isLaptop = window.innerWidth > 1024;
      return isLaptop ? "Laptop" : "Unknown Device";
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      // console.log("Back button clicked or history changed:", event);
      // alert("back button");
      // Navigate to the home page
      navigate("/");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      if (window.innerWidth <= 400) {
        setDialogWidth("90vw");

        setLoadingMargin("0rem");
      } else if (window.innerWidth <= 475) {
        setDialogWidth("74vw");
      } else if (window.innerWidth <= 550) {
        setLoadingMargin("0rem");
      } else if (window.innerWidth <= 575) {
        setDialogText("0.6rem");
        setDialogWidth("65vw");
      } else if (window.innerWidth <= 650) {
        setDialogWidth("57vw");
      } else if (window.innerWidth <= 775) {
        setDialogWidth("50vw");
      } else if (window.innerWidth <= 875) {
        setDialogWidth("42vw");
      } else if (window.innerWidth <= 1000) {
        setDialogWidth("37vw");
      } else if (window.innerWidth <= 1100) {
        setDialogWidth("33vw");
        setDialogText("0.8rem");
      } else if (window.innerWidth <= 1300) {
        setDialogWidth("29vw");
      } else {
        setDialogWidth("25vw");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (deviceType !== "Android") {
      let locationGranted = false;
      let cameraGranted = false;

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            setPosition({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
            setLocationPerm(true);
            console.log("location called", "275");
            locationGranted = true;
            checkPermissions();
          },
          (error) => {
            console.log(error);
            setLocationPerm(false);
            checkPermissions();
          }
        );
      }

      const checkPermissions = () => {
        navigator.permissions
          .query({ name: "camera" })
          .then((permissionStatus) => {
            if (permissionStatus.state === "granted") {
              setCameraPerm(true);
              cameraGranted = true;
            } else if (permissionStatus.state === "prompt") {
              setCameraPerm(true);
              cameraGranted = true;
              // Prompt the user for camera permission
              navigator.mediaDevices
                .getUserMedia({ video: true })
                .then(() => {
                  console.log("Prompting for camera permissions");
                })
                .catch((error) => {
                  setCameraPerm(false);
                  cameraGranted = false;
                  console.log("Error:", error);
                });
            } else {
              setCameraPerm(false);
              cameraGranted = false;
            }

            if (locationGranted && cameraGranted) {
              setCamLocPerm(true);
              // setOpen(true)
            } else {
              setCamLocPerm(false);
            }
          })
          .catch((error) => console.log("Error:", error));
      };
    }
  }, [deviceType]);

  // working fine in android

  const checkGeolocationPermission = () => {
    if ("geolocation" in navigator) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          console.log(permissionStatus);

          if (permissionStatus.state === "granted") {
            setLocationPerm(true);
          }
          // else if (permissionStatus.state === "prompt") {
          //   setLocationPerm(true);
          // }
          else {
            setLocationPerm(false);
          }
        })
        .catch((error) => {
          console.error("Error checking geolocation permission:", error);
          setLocationPerm(false);
        });
    }
  };
  const checkCameraPermission = () => {
    navigator.permissions
      .query({ name: "camera" })
      .then((permissionStatus) => {
        if (permissionStatus.state === "granted") {
          setCameraPerm(true);
        } else if (permissionStatus.state === "prompt") {
          setCameraPerm(true);
          // Prompt the user for camera permission if needed
        } else {
          setCameraPerm(false);
        }
      })
      .catch((error) => {
        console.error("Error checking camera permission:", error);
      });
  };
  useEffect(() => {
    if (deviceType === "Android") {
      checkGeolocationPermission();
      checkCameraPermission();
    }
  }, [deviceType]);

  // Update camLocPerm based on locationPerm and cameraPerm
  useEffect(() => {
    if (position.latitude && position.longitude) {
      // getLocation(position.latitude, position.longitude);
      console.log(position.latitude, position.longitude, "338");
      dispatch(
        set_latitude_longitude({
          latitude: position.latitude,
          longitude: position.longitude,
        })
      );
      setLocation({
        latitude: position.latitude,
        longitude: position.longitude,
      });
    }
  }, [position.latitude, position.longitude]);

  // Function to fetch location details using latitude and longitude
  const getLocation = async (latitude, longitude) => {
    try {
      const response = await axios.post("/get_code/get_rto_code", {
        latitude: latitude,
        longitude: longitude,
      });
      let rto_code = response.data.replace("-", "");
      // console.log(rto_code);

      // const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
      // const data = await response.json();
      // setLocation(response.data);
      const time = moment();
      const formattedDate = time.format("DDMMM").toUpperCase();
      // console.log(formattedDate);
      const prefix = `${rto_code}${formattedDate}`;
      const res = await axios.post("/process_data/getNextAudit", {
        prefix: prefix,
      });
      // console.log(res.data);
      dispatch(setLoading(false));
      return res.data;
    } catch (error) {
      console.log("Error fetching location:", error);
    }
  };
  //console.log(locationPerm, camLocPerm, cameraPerm, "326");

  const handleButtonClick = async () => {
    setOpen(true);
 
  };


  const handleLocationCameraPermission = () => {
    window.location.reload();
  };
  const [open, setOpen] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const { requestFullscreen } = useFullscreen();

  const handleFullscreenRequest = () => {
    requestFullscreen();
    setOpen(false);
      
    dispatch(setLoading(true));
    if ("geolocation" in navigator) {
      try {
        if (locationPerm && cameraPerm) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              // const { latitude, longitude } = position.coords;
              // const audit = await getLocation(latitude, longitude);
              dispatch(setAuditID(audit_id));
              // navigate("/landing-page");
              navigate("/camera-hybrid");
              
            },
            (error) => {
              setShowError(`Error getting location: ${error.message}`);
              console.log("here", "in error");
              // setOpenPermissionDialog(true);
              let alert = {
                snackbarOpen: true,
                snackbarMessage: `${error.message}`,
                snackbarMessageSeverity: "error",
              };
              dispatch(
                setAlertMessageSnackbarMessageSeverity(
                  alert.snackbarMessageSeverity
                )
              );
              dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
              dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
              setTimeout(() => {
                dispatch(setAlertMessageSnackbarOpen(false));
              }, 1);
            }
          );
        } else if (!locationPerm && !cameraPerm) {
          setOpenPermissionDialog(true);
        } else if (!locationPerm) {
          setOpenLocPermissionDialog(true);
        } else if (!cameraPerm) {
          setOpenCamPermissionDialog(true);
        }
        dispatch(setLoading(false));
      } catch (error) {
        console.error("Error querying location permission:", error);
        // Handle the error appropriately
      }
    } else {
      showError("Geolocation is not available in your browser.");
    }
   
  };

  const handleClose = (event) => {
    if (
      event.target.tagName.toLowerCase() !== "button" &&
      !event.target.closest("button")
    ) {
      // Prevent dialog from closing if click occurred outside of the button
      return;
    }
    setOpenSupport(false);
  };
  const testSpeed = async () => {
    
    const fileSize = 5 * 1024 * 1024; // 5MB file
    const testFile = 'https://speed.cloudflare.com/__down?bytes=5000000'; // Cloudflare test file

    const startTime = new Date().getTime();

    try {
      const response = await fetch(testFile);
      await response.arrayBuffer();

      const endTime = new Date().getTime();
      const durationInSeconds = (endTime - startTime) / 1000;
      const speedMbps = (fileSize / durationInSeconds / (1024 * 1024) * 8).toFixed(2);

      setSpeed(speedMbps);
    } catch (error) {
      console.error('Speed test failed:', error);
      setSpeed('Error');
    }

  };
  useEffect(() => {
    const intervalId = setInterval(testSpeed, 2000); // Poll every 2 seconds
    
    // Cleanup function to clear the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

console.log(lastSlide,"505")
  return (
    <>
      <div
        // className="outer-div"
        style={{ backgroundSize: "cover" }}
      >
        {/* <Topbar /> */}
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          {loading && <LinearProgress style={{ marginTop: loadingMargin }} />}
        </div>

        <div
          className="outer-div"
          style={{ backgroundSize: "cover" }}
        >
          {/* <Topbar /> */}
          <div
            style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}
          >
            {loading && <LinearProgress style={{ marginTop: loadingMargin }} />}
          </div>
       

          <div className="start-inspection-div">
          {speed !==null && <InternetSignal signalStrength={speed}/> }
      <img
        src={query_icon}
        alt="Query Icon"
        className="question-div"
        onClick={handleClickOpen}
      />

      {/* Support Popup */}
      <Dialog open={openSupport} onClose={handleClose} className="support-popup-dialog">
        <DialogContent className="support-popup-content">
          <Support />
          <button onClick={handleClose} className="close-btn">Close</button>
        </DialogContent>
      </Dialog>
      {/* <div className="permissions-page"> */}
        <StepIndicator stepNumber={2} customClass="step-indicator-instructions"/>
 {/* </div> */}
            <div
              className="follow-instruction-header"
            >
              Follow instructions
            </div>
            <div
             className="instruction-header"
              
            >
              Learn how to take photos correctly
            </div>
            <InstructionSlider setLastSlide={setLastSlide}/>
            <Dialog
              open={open}
              onClose={handleClose}
              className="full_screen_class"
              PaperProps={{
                style: {
                  width: dialogWidth,
                  padding: "0.5rem 0.5rem",
                  paddingBottom: "0.5rem",
                  borderRadius: "4px",
                  // position:"absolute",
                  // top:"0",
                  margin: "0",
                },
              }}
            >
              <DialogContent sx={{ padding: "0.2rem 0.3rem" }}>
                <DialogTitle
                  style={{
                    fontSize: dialogText,
                    // textAlign: "center",
                    color: "black",
                    padding: "0.4rem 0",
                    fontWeight: "600",
                  }}
                >
                  Full Screen Mode ?
                </DialogTitle>
                <DialogContentText sx={{ color: "black", fontSize: "0.8rem" }}>
                  Switch to full screen mode.
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ padding: "0.4rem" }}>
                <div
                  style={{
                    // border: "1px solid #367588",
                    // borderRadius: "30px",
                    padding: "0.1rem",
                  }}
                >
                  <button
                    onClick={handleFullscreenRequest}
                    style={{
                      color: "white",
                      backgroundColor: "#ff0066",
                      border: "none",
                      padding: "0.4rem 0.8rem",
                      textTransform: "capitalize",
                      borderRadius: "20px",
                      cursor: "pointer",
                    }}
                  >
                    Switch
                  </button>
                </div>
              </DialogActions>
            </Dialog>
           
            <div style={{ marginTop: "1rem" }}>
              <button disabled={lastSlide}  onClick={handleButtonClick}  style={{
                  backgroundColor: lastSlide ? "#dcdcdc" : "#FF0083",
                  
                  // marginBottom: "1rem",
                  marginTop: "1rem",
                  fontWeight: "400",
                  // fontStyle: "normal",
                  fontSize: "0.9rem",
                  lineHeight:"24px",
                  borderRadius:"3px",
                  cursor:"pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  // border: "1px solid #ff66b2", // Adjust border color to a lighter pinkish shade
                  color: lastSlide ? "#0000003D":"#ffffff", // White color for text
                  // letterSpacing: "1px",
                  padding: "0.2rem 3rem",
                  // boxShadow: "0px 0px 0px 2px #ff66b2 inset", // Adjust shadow color to match border
                  "@media (max-width: 1300px)": {
                    fontWeight: "600 !important",
                  },
                  "@media (max-width: 700px)": {
                    fontWeight: "500 !important",
                  },
                  "@media screen and (max-width: 900px) and (orientation: landscape)": {
                    lineHeight: "1",
                  },
                  "@media screen and (max-width: 850px) and (orientation: landscape)": {
                    lineHeight: "1.1",
                  },
                  "@media screen and (max-width: 700px) and (orientation: landscape)": {
                    lineHeight: "1.3",
                  },}}>
              Proceed to inspection
              </button>
              {/* <Button
                size="small"
                endIcon={<StartIcon />}
                variant="outlined"
                onClick={handleButtonClick}
                sx={{
                  backgroundColor: "#ff0066 !important", // Change this to your desired pinkish color
                  marginBottom: "1rem",
                  marginTop: "1rem",
                  fontFamily: "'Jersey 20', sans-serif",
                  fontWeight: "400",
                  fontStyle: "normal",
                  fontSize: "1rem",
                  border: "1px solid #ff66b2", // Adjust border color to a lighter pinkish shade
                  color: "#ffffff", // White color for text
                  letterSpacing: "1px",
                  padding: "0.2rem 3rem",
                  // boxShadow: "0px 0px 0px 2px #ff66b2 inset", // Adjust shadow color to match border
                  "@media (max-width: 1300px)": {
                    fontWeight: "600 !important",
                  },
                  "@media (max-width: 700px)": {
                    fontWeight: "500 !important",
                  },
                  "@media screen and (max-width: 900px) and (orientation: landscape)": {
                    lineHeight: "1",
                  },
                  "@media screen and (max-width: 850px) and (orientation: landscape)": {
                    lineHeight: "1.1",
                  },
                  "@media screen and (max-width: 700px) and (orientation: landscape)": {
                    lineHeight: "1.3",
                  },
                }}
              >
                Proceed to inspection
              </Button> */}


              {/* <span>
                  {camLocPerm.toString()} || {locationPerm.toString()} ||{" "}
                  {cameraPerm.toString()}
                </span> */}
            </div>
          </div>

          {/* 1 */}
          <Dialog
            open={openPermissionDialog}
            sx={{ zIndex: "99999999999999999999" }}
            // onClose={handleDialogClose}
            maxWidth="150vw"
            maxHeight="lg"
            PaperProps={{
              style: {
                width: dialogWidth,
                padding: "0.5rem 0.5rem",
                paddingBottom: "0.5rem",
                borderRadius: "0.9rem",
                boxSizing: "border-box",
              },
            }}
          >
            <DialogTitle
              style={{
                fontSize: dialogText,
                textAlign: "center",
                color: "black",
                padding: "0.6rem ",
                fontWeight: "bold",
              }}
            >
              To continue, please enable Location & Camera permissions
            </DialogTitle>
            <DialogContent style={{ padding: "0.5rem" }}>
              <div className="enable-permissions">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                  }}
                >
                  <img src={location_gif} style={{ width: "5rem" }} />
                  <img src={camera_gif} style={{ width: "5rem" }} />
                </div>
                {deviceType === "Laptop" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>
                      1. Open info icon in the top header to view site settings.
                    </span>
                    <span>2. Go to site settings.</span>
                    <span>3. Set camera & location preferences to "ALLOW"</span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "iPhone" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location Services.</span>
                    <span>3. Set location as "ON".</span>
                    <span>
                      4. Below view safari/chrome -- "Allow only while using the
                      app"{" "}
                    </span>
                    <span>5. Search Camera.</span>
                    <span>
                      6. Set camera as "ON" for the browser use are using.
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "Android" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location.</span>
                    <span>3. Set location as "ON".</span>
                    <span>4. Then, search "chrome" browser.</span>
                    <span>
                      5. In chrome -- permissions -- Location -- "Allow only
                      while using the app"{" "}
                    </span>
                    <span>6. Search Camera.</span>
                    <span>
                      7. Set camera as "ON" for the browser use are using.
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "Unknown Device" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location.</span>
                    <span>3. Set location as "ON".</span>
                    <span>4. Then, search "chrome" browser.</span>
                    <span>
                      5. In chrome -- permissions -- Location -- "Allow only
                      while using the app"{" "}
                    </span>
                    <span>6. Search Camera.</span>
                    <span>
                      7. Set camera as "ON" for the browser use are using.
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  onClick={() => {
                    setOpenPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
              {/* </MuiAlert> */}
            </DialogContent>
          </Dialog>
          {/* 2 */}
          <Dialog
            open={openLocPermissionDialog}
            sx={{ zIndex: "99999999999999999999" }}
            // onClose={handleDialogClose}
            maxWidth="150vw"
            maxHeight="lg"
            PaperProps={{
              style: {
                width: dialogWidth,
                padding: "0.5rem 0.5rem",
                paddingBottom: "0.5rem",
                borderRadius: "0.9rem",
                boxSizing: "border-box",
              },
            }}
          >
            <DialogTitle
              style={{
                fontSize: dialogText,
                textAlign: "center",
                color: "black",
                padding: "0.6rem ",
                fontWeight: "bold",
              }}
            >
              To continue, please enable Location permissions
            </DialogTitle>
            <DialogContent style={{ padding: "0.5rem" }}>
              <div className="enable-permissions">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                  }}
                >
                  <img src={location_gif} style={{ width: "5rem" }} />
                </div>

                {deviceType === "Laptop" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>
                      1. Open info icon in the top header to view site settings.
                    </span>
                    <span>2. Go to site settings.</span>
                    <span>3. Set location preference to "ALLOW"</span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "iPhone" && (
                  <div
                    style={{ listStyleType: "decimal", textAlign: "justify" }}
                  >
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location Services.</span>
                    <span>3. Set location as "ON".</span>
                    <span>
                      4. Below view safari/chrome -- "Allow only while using the
                      app"{" "}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "Android" && (
                  <div
                    style={{ listStyleType: "decimal", textAlign: "justify" }}
                  >
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location.</span>
                    <span>3. Set location as "ON".</span>
                    <span>4. Then, search "chrome" browser.</span>
                    <span>
                      5. In chrome -- permissions -- Location -- "Allow only
                      while using the app"{" "}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}
                {deviceType === "Unknown Device" && (
                  <div
                    style={{ listStyleType: "decimal", textAlign: "justify" }}
                  >
                    <span>1. Open Settings app.</span>
                    <span>2. Search Location.</span>
                    <span>3. Set location as "ON".</span>
                    <span>4. Then, search "chrome" browser.</span>
                    <span>
                      5. In chrome -- permissions -- Location -- "Allow only
                      while using the app"{" "}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontStyle: "italic",
                      }}
                    >
                      --- Reload the page ---
                    </span>
                  </div>
                )}

                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  onClick={() => {
                    setOpenLocPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
              {/* </MuiAlert> */}
            </DialogContent>
          </Dialog>
          {/* 3 */}
          <Dialog
            open={openCamPermissionDialog}
            sx={{ zIndex: "99999999999999999999" }}
            // onClose={handleDialogClose}

            maxWidth="150vw"
            maxHeight="lg"
            PaperProps={{
              style: {
                width: dialogWidth,
                padding: "0.5rem 0.5rem",
                paddingBottom: "0.5rem",
                borderRadius: "0.9rem",
                boxSizing: "border-box",
              },
            }}
          >
            <DialogTitle
              style={{
                fontSize: dialogText,
                textAlign: "center",
                color: "black",
                padding: "0.6rem ",
                fontWeight: "bold",
              }}
            >
              To continue, please enable Camera permissions
            </DialogTitle>
            <DialogContent style={{ padding: "0.5rem" }}>
              <div className="enable-permissions">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                  }}
                >
                  <img src={camera_gif} style={{ width: "5rem" }} />
                </div>
                {deviceType === "Laptop" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>
                      1. Open info icon in the top header to view site settings.
                    </span>
                    <span>2. Go to site settings.</span>
                    <span>3. Set camera preference to "ALLOW"</span>
                    <span>--- Reload the page ---</span>
                  </div>
                )}
                {deviceType === "iPhone" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Camera.</span>
                    <span>
                      3. Set camera as "ON" for the browser use are using.
                    </span>
                    <span>--- Reload the page ---</span>
                  </div>
                )}
                {deviceType === "Android" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Camera.</span>
                    <span>
                      3. Set camera as "ON" for the browser use are using.
                    </span>
                    <span>--- Reload the page ---</span>
                  </div>
                )}
                {deviceType === "Unknown Device" && (
                  <div style={{ listStyleType: "decimal" }}>
                    <span>1. Open Settings app.</span>
                    <span>2. Search Camera.</span>
                    <span>
                      3. Set camera as "ON" for the browser use are using.
                    </span>
                    <span>--- Reload the page ---</span>
                  </div>
                )}

                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  onClick={() => {
                    setOpenCamPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
              {/* </MuiAlert> */}
            </DialogContent>
          </Dialog>
        
          {speed && speed<5 &&  <Dialog
            open={openDialogLowInternet}
            onClose={handleDialogClose}
            maxWidth="150vw"
            maxHeight="lg"
            PaperProps={{
              style: {
                width: dialogWidth,
                // padding: "1.5rem 1rem",
                // paddingBottom: "0.5rem",
                borderRadius: "4px",
                margin: "0px",
                height: "120px",
                zIndex: "999999"
              },
            }}
          >


            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",

                gap: "0.3rem",
                fontSize: "1.3rem",
                textAlign: "center",
                color: "black",
                padding: "1rem 0.9rem",
                fontWeight: "600",
                fontFamily: 'Barlow Condensed',
              }}
            >

             
             
                <>
                  <img src={network} style={{ width: "9%" }} />
                  <span >Low internet connection</span>
                </>
             
            </DialogTitle>
            <div style={{ padding: "0 1rem", fontFamily: "'Montserrat', sans-serif", }} >
              Please switch to a more stable connection to continue seamlessly
            </div>
            <IconButton
                                aria-label="close"
                                onClick={handleDialogClose}
                                sx={{
                                    position: "absolute",
                                    right: 7,
                                    top: 10,
                                    color: "black",
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
          </Dialog>}
        </div>
      </div>

      <SnackbarAlert />
    </>
  );
};

export default StartInspectionHybrid;
